type TInput = {
  isDefaultTeam: boolean;
  memberUserId: string;
  currentUserId: string;
  memberCount: number;
};

export const canRemoveTeamMember = ({ isDefaultTeam, memberUserId, currentUserId, memberCount }: TInput): boolean =>
  !isDefaultTeam || (memberUserId !== currentUserId && memberCount >= 2);
